import React, { forwardRef } from 'react';
import styled from 'styled-components';

import GlobalHeader from 'components/global-header';
import GlobalFooter from 'components/global-footer';
import { GlobalNavigationDesktop } from 'shop/components/navigation/global-navigation/desktop';

type LayoutWithHeaderProps = {
  children: React.ReactNode;
  hideFooter?: boolean;
  isMarketplace?: boolean;
};

const LayoutWithHeader = forwardRef<HTMLDivElement, LayoutWithHeaderProps>((props, ref) => {
  const { hideFooter, isMarketplace, children, ...otherProps } = props;

  return (
    <Container ref={ref}>
      {isMarketplace ? <GlobalNavigationDesktop /> : <GlobalHeader />}
      <Content {...otherProps}>{children}</Content>
      {!hideFooter && <GlobalFooter />}
    </Container>
  );
});

export default LayoutWithHeader;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const Content = styled.div`
  flex: 1 0 0%;
`;
